import { ca } from '@cian/analytics';

export const trackRepresentativeTooltipOpen = (id: number, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'official_representative',
    action: 'open',
    label: 'official_representative_tooltip',
    products: [{ id, position }],
  });
};
